import { Injectable } from '@angular/core';
import {RestHttpService} from "@catcore/services/rest-http.service";
import {Restangular} from "ngx-restangular";

@Injectable()
export class ProjectGgwDynamicRouteService extends RestHttpService<any> {

  constructor(private service: Restangular) {
    super('project-ggw-dynamic-routes', service);
  }

}



// WEBPACK FOOTER //
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_release@2/app/Resources/Public/src/app/modules/models/ggw-dynamic-routes/services/project-ggw-dynamic-route.service.ts